import { useAuth } from "@/lib/auth";
import PaymentLinksList from "@/pages/PaymentLinksList";

export default function PartnerPaymentLinks() {
    const { user } = useAuth();
    const businessName = user?.partner?.business_name || "";
    return (
        <div className="space-y-5 max-w-4xl">
            <div>
                <h1 className="text-2xl font-bold tracking-tight">Payment links</h1>
                <p className="text-sm text-slate-500 mt-1">
                    Run multiple websites? Create a separate payment link for each — branded
                    name, redirect URLs and channel allowlist per link. Optionally point your
                    own subdomain (e.g. <code className="font-mono">pay.yoursite.com</code>) to
                    any link.
                </p>
            </div>
            <div className="card p-5">
                <PaymentLinksList scope="partner" partnerBusinessName={businessName} />
            </div>
        </div>
    );
}
